export const PERMISSIONS = {
  Dashboard: {
    Read: 'vt-read-dashboard',
  },

  Users: {
    Read: 'vt-read-users',
    Create: 'vt-create-users',
    Update: 'vt-update-users',
    Delete: 'vt-delete-users',
  },

  Roles: {
    Read: 'vt-read-roles',
    Create: 'vt-create-roles',
    Update: 'vt-update-roles',
    Delete: 'vt-delete-roles',
  },

  Areas: {
    Read: 'vt-read-areas',
    Create: 'vt-create-areas',
    Delete: 'vt-delete-areas',
  },

  Orders: {
    Read: 'vt-read-order',
    Create: 'vt-create-order',
    Update: 'vt-update-order',
    Delete: 'vt-delete-order',
    Approve: 'vt-approve-order',
  },

  Templates: {
    Read: 'vt-read-template',
    Create: 'vt-create-template',
    Update: 'vt-update-template',
    Delete: 'vt-delete-template',
  },

  Fields: {
    Read: 'vt-read-field',
    Create: 'vt-create-field',
    Update: 'vt-update-field',
    Delete: 'vt-delete-field',
  },

  Customers: {
    Read: 'vt-read-customers',
    Create: 'vt-create-customers',
    Update: 'vt-update-customers',
    Delete: 'vt-delete-customers',
    Sync: 'vt-sync-customers',
  },

  Documents: {
    Read: 'vt-read-documents',
    Upload: 'vt-upload-documents',
  },

  ProductionLines: {
    Read: 'vt-read-production-lines',
    Create: 'vt-create-production-lines',
    Update: 'vt-update-production-lines',
    Delete: 'vt-delete-production-lines',
  },

  Inventory: {
    Read: 'vt-read-inventory-items',
    Create: 'vt-create-inventory-items',
    Update: 'vt-update-inventory-items',
    Delete: 'vt-delete-inventory-items',
  },

  PermissionsCatalog: {
    Read: 'vt-read-permissions',
    Create: 'vt-create-permissions',
    Update: 'vt-update-permissions',
    Delete: 'vt-delete-permissions',
  },

  Billing: {
    ManagePlatform: 'vt-manage-platform-billing',
  },

  Integrations: {
    ManageSiigoCredentials: 'vt-manage-siigo-credentials',
  },
} as const;

/**
 * Flat list of all permission strings recognized by the application.
 * Used for seeding or validating against the backend catalog.
 *
 * The actual role ↔ permission assignment lives entirely in the backend.
 * The frontend only reads permissions from the JWT / session response
 * and evaluates them via UserStateService.hasPermission().
 */
export type Permission =
  (typeof PERMISSIONS)[keyof typeof PERMISSIONS][keyof (typeof PERMISSIONS)[keyof typeof PERMISSIONS]];
